import type { IconData } from '@stacksjs/iconify-core'

export const interfaceEssentialNoteMusic: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M28.185 6.86h-3.05v1.52h3.05v12.19h-3.05v1.53h-1.52v3.04h1.52v1.53h3.05v-1.53h1.53V.76h-4.58v1.53h3.05z\"/><path fill=\"currentColor\" d=\"M20.565 8.38h4.57v1.53h-4.57Zm0-6.09h4.57v1.52h-4.57Zm-4.57 7.62h4.57v1.52h-4.57Zm0-6.1h4.57v1.53h-4.57Zm-4.57 7.62h4.57v1.52h-4.57Zm0-6.09h4.57v1.52h-4.57Zm-7.62 25.9h3.05v-1.52h1.52V14.48h3.05v-1.53h-3.05V8.38h3.05V6.86h-4.57v18.28h-3.05v1.53h-1.52v3.05h1.52z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default interfaceEssentialNoteMusic
